import { useState } from 'react';
import { useParams, useSearchParams } from 'react-router';
import { Trans } from '@lingui/react/macro';

import { GenericError } from '@/components/GenericError/GenericError';
import Paragraph from '@/design_system/Typography/Paragraph';
import { useAgreement } from '@/models/agreements';
import { ErrorState } from '@/routes/SettingsBeta/components/ErrorState';
import { Loading } from '@/routes/SettingsBeta/components/Loading';
import { NotFoundError } from '@/utils/error/NotFoundError';

import { AgreementEdit } from './AgreementEdit';
import { AgreementRead } from './AgreementRead';

export const Agreement = () => {
  const { id } = useParams();
  const [searchParams] = useSearchParams();

  const [isEditing, setIsEditing] = useState(searchParams.get('edit') === 'true');

  const { data: agreement, isLoading, isError, error } = useAgreement(id, { enabled: !!id });

  if (isLoading) {
    return <Loading />;
  }

  if (isError || !agreement) {
    let errorMessage = <GenericError />;

    if (error instanceof NotFoundError) {
      errorMessage = (
        <Paragraph>
          <Trans id="settings.organization.entities.agreements.detail.not-found">
            This agreement could not be found or you do not have access to it.
          </Trans>
        </Paragraph>
      );
    }

    return <ErrorState errorMessage={errorMessage} />;
  }

  if (isEditing) {
    return <AgreementEdit agreement={agreement} onSaveOrCancel={() => setIsEditing(false)} />;
  }

  return <AgreementRead agreement={agreement} onEdit={() => setIsEditing(true)} />;
};
